import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Tooltip from '../tooltip/Tooltip.jsx';
import s from './ToggleButton.module.scss';

const ToggleButton = props => {
    const { active, activeIcon, activeText, inactiveIcon, inactiveText, onButtonClick, showTooltip, arrowPosition, className, borderType } = props;
    return (
        <div className={s.buttonWrapper}>
            <button className={classNames(s.toggleButton, s.removeButtonStyling, s.size, active ? s.active : s.inactive, s[borderType], className)} type="button" onClick={onButtonClick}>
                <div className={classNames(active ? activeIcon : inactiveIcon, s.icon)} />
                {showTooltip && <Tooltip arrowPosition={arrowPosition} text={active ? activeText : inactiveText} />}
            </button>
        </div>
    );
};

ToggleButton.propTypes = {
    active: PropTypes.bool.isRequired,
    activeIcon: PropTypes.string.isRequired,
    activeText: PropTypes.string.isRequired,
    borderType: PropTypes.string.isRequired,
    inactiveIcon: PropTypes.string.isRequired,
    inactiveText: PropTypes.string.isRequired,
    onButtonClick: PropTypes.func.isRequired,
    showTooltip: PropTypes.bool.isRequired,
    arrowPosition: PropTypes.string.isRequired,
    className: PropTypes.string,
};

ToggleButton.defaultProps = { className: '' };

export default ToggleButton;
